var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 0 4 4L4 16H0v-4L12 0ZM1 12.707V15h2.293L1 12.707Zm8.854-9.146-8.293 8.293 2.585 2.585 8.293-8.293-2.585-2.585ZM12 1.415l-1.439 1.439 2.585 2.585L14.585 4 12 1.415Z",
    fill: "#000",
    fillRule: "evenodd"
  })));
};
export default SvgEdit;